namespace TabAurous.Scheme {
    export interface SchemePaymentDetailsForm {
        LedgerId: Serenity.IntegerEditor;
        ModeId: Serenity.LookupEditor;
        Amount: Serenity.DecimalEditor;
        ChequeNo: Serenity.MaskedEditor;
        ChequeDate: Serenity.DateEditor;
        RefNo: Serenity.StringEditor;
    }

    export class SchemePaymentDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'Scheme.SchemePaymentDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SchemePaymentDetailsForm.init)  {
                SchemePaymentDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.MaskedEditor;
                var w4 = s.DateEditor;
                var w5 = s.StringEditor;

                Q.initFormType(SchemePaymentDetailsForm, [
                    'LedgerId', w0,
                    'ModeId', w1,
                    'Amount', w2,
                    'ChequeNo', w3,
                    'ChequeDate', w4,
                    'RefNo', w5
                ]);
            }
        }
    }
}
